export enum DashboardRangeEnum {
  RANGE_30T = "30T",
  RANGE_90T = "90T",
  RANGE_12M = "12M",
  RANGE_5J = "5J"
}
